<template>
  <div
    v-if="visible"
    class="cookie-banner"
    role="dialog"
    aria-label="Согласие на использование файлов cookie"
  >
    <div class="cookie-banner__text">
      Мы используем файлы cookie и сервис «Яндекс.Метрика», чтобы анализировать, как
      используется сайт. Метрика включается только с вашего согласия.
      Подробнее — в
      <a href="/politica.html" target="_blank" rel="noopener noreferrer"
        >политике обработки персональных данных</a
      >.
    </div>
    <div class="cookie-banner__actions">
      <button
        type="button"
        class="cookie-banner__btn cookie-banner__btn--accept"
        @click="accept"
      >
        Принять
      </button>
      <button
        type="button"
        class="cookie-banner__btn cookie-banner__btn--decline"
        @click="decline"
      >
        Отклонить
      </button>
    </div>
  </div>
</template>

<script>
import {
  CONSENT_ACCEPTED,
  CONSENT_DECLINED,
  getConsent,
  initMetrika,
  saveConsent,
} from '@/utils/metrika';

export default {
  name: 'CookieBanner',
  data() {
    return {
      visible: !getConsent(),
    };
  },
  mounted() {
    // решение уже принято ранее — поднимаем Метрику, баннер не показываем
    initMetrika();
  },
  methods: {
    accept() {
      saveConsent(CONSENT_ACCEPTED);
      this.visible = false;
      initMetrika();
    },
    decline() {
      saveConsent(CONSENT_DECLINED);
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  padding: 15px 5%;
  background: #fff;
  border-top: 1px solid #dcdcdc;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
}

.cookie-banner__text {
  flex: 1 1 400px;
  font-size: 15px;
  line-height: 1.4;
  color: #333;
}

.cookie-banner__text a {
  color: #16683f;
  text-decoration: underline;
}

.cookie-banner__actions {
  display: flex;
  gap: 10px;
}

.cookie-banner__btn {
  padding: 10px 25px;
  font-size: 15px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid transparent;
}

.cookie-banner__btn--accept {
  background: #16683f;
  color: #fff;
}

.cookie-banner__btn--accept:hover {
  background: #125434;
}

.cookie-banner__btn--decline {
  background: #f2f2f2;
  color: #333;
  border-color: #ccc;
}

.cookie-banner__btn--decline:hover {
  background: #e6e6e6;
}

@media screen and (max-width: 617px) {
  .cookie-banner {
    flex-direction: column;
    align-items: stretch;
    text-align: left;
  }

  .cookie-banner__actions {
    justify-content: stretch;
  }

  .cookie-banner__btn {
    flex: 1;
  }
}
</style>
